import { render, staticRenderFns } from "./activity-card.vue?vue&type=template&id=252ad9c4&scoped=true"
import script from "./activity-card.vue?vue&type=script&lang=js"
export * from "./activity-card.vue?vue&type=script&lang=js"
import style0 from "./activity-card.vue?vue&type=style&index=0&id=252ad9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ad9c4",
  null
  
)

export default component.exports